import { apiBaseUrl } from "./config"
import { genericFetch } from "./common-service"
import UrlSegments from "./constant/url-segment"
import { RegionRequestBody } from "./request-body"
import { getBaseHeader } from "./utils"
import { Region, Service} from "../../model"

const usersBaseUrl = `${apiBaseUrl}/${UrlSegments.LOCAL_AUTHORITIES}/${UrlSegments.REGIONS}`

export function createUser(user: RegionRequestBody): Promise<Region> {
	const init: RequestInit = {
		body: JSON.stringify(user),
		headers: getBaseHeader(true),
		method: "POST"
	}
	return genericFetch<Region>(usersBaseUrl, init)
}

export function deleteUser(user: Region): Promise<void> {
	const url = `${usersBaseUrl}/${user.id}`
	const init: RequestInit = {
		headers: getBaseHeader(),
		method: "DELETE"
	}
	return genericFetch<void>(url, init)
}


export function findUser(userId: number): Promise<Region> {
	const url = `${usersBaseUrl}/${userId}`
	const init = { headers: getBaseHeader(true) }
	return genericFetch<Region>(url, init)
}

export function findRegions(): Promise<Region[]> {
	const init: RequestInit = {
		headers: getBaseHeader()
	}
	return genericFetch<Region[]>(usersBaseUrl, init)
}

// export function findUserServices(
// 	user: Region,
// 	signal: AbortSignal
// ): Promise<Service[]> {
// 	const url = `${usersBaseUrl}/${user.id}/services`
// 	const init: RequestInit = {
// 		headers: {
// 			...getBaseHeader(),
// 			"Content-Type": "application/json"
// 		},
// 		signal
// 	}

// 	return genericFetch<Service[]>(url, init)
// }


export function updateUser(userId: number, user: RegionRequestBody): Promise<Region> {
	const url = `${usersBaseUrl}/${userId}`
	const init: RequestInit = {
		body: JSON.stringify(user),
		headers: getBaseHeader(true),
		method: "PUT"
	}
	return genericFetch<Region>(url, init)
}



// WEBPACK FOOTER //
// ./src/service/sfp/regions-service.ts